import { Icon } from '@festina-life/ui/structure'

import type { ConciseChangesetWithBranchKey } from '../../../../uiModels/changesets/types'

type Props = {
  changeset: ConciseChangesetWithBranchKey
}

export const ChangesetKey = ({ changeset }: Props) => (
  <div className="flex items-center gap-x-2 text-sm">
    <Icon name="Key" />
    <span>{changeset.changesetKey ?? '-'}</span>
  </div>
)
